import { LevelAbbreviations } from "../Types";

export const FiasRoomTypes: LevelAbbreviations[] = [
    {
        long: "Не определено",
        short: "Не определено",
        fiasKey: "0",
    },
    {
        long: "Комната",
        short: "ком.",
        fiasKey: "1",
    },
    {
        long: "Помещение",
        short: "помещ.",
        fiasKey: "2",
    },
];
